import { Component, OnInit } from '@angular/core';
import { ActivationStart, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { AuthService } from './core/security/auth.service';
import { GoogleAnalyticsService } from './analytics/google-analytics.service';
import { MatIconRegistry } from '@angular/material/icon';
import { VersionCheckerService } from './core/services/version-checker.service';
import { NotificationComponent } from './notification/notification.component';
import moment from 'moment';
import { RouterGenerator } from './generate-routes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NotificationComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(
    public matIconRegistry: MatIconRegistry,
    private router: Router,
    private authService: AuthService,
    private versionChecker: VersionCheckerService,
    private gaService: GoogleAnalyticsService,
  ) {
    //this.matIconRegistry.registerFontClassAlias('fas');
    this.router.events.subscribe(event => {
      if (event.constructor.name === 'ActivationStart') {
        const e = event as ActivationStart;

        if (e.snapshot.data) {
          this.authService.currentMenuGroup.next(e.snapshot.data['menuGroup']);
        }
      } else if (event instanceof NavigationEnd) {
        this.gaService.navigateTo(event);
      } else if (event instanceof NavigationError) {
        console.error(event.error);
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(event.error.message)) {
          window.location.reload();
        }
      }
    });

    this.versionChecker.initCheckForUpdates('version.json');
  }

  ngOnInit() {
    this.initMoment();
    // Enable this to generate a route file, copy a source from the console and paste to app/core/routes/all-routes.ts
    //todo: this.generateRoute();
  }

  initMoment(): void {
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: '%d s',
        ss: '%d s',
        m: '%d min',
        mm: '%d min',
        h: '%d h',
        hh: '%d h',
        d: '%d d',
        dd: '%d d',
        M: '%d m',
        MM: '%d m',
        y: '%d y',
        yy: '%d y',
      },
    });
  }

  generateRoute() {
    RouterGenerator.initAllModules().then(() => {
      const allRoutesJson = JSON.stringify(RouterGenerator.allRoutes, null, 2);

      const fileTemplate = `import {RouteHelperItem} from '../utilities/router-helper';

export const routes: RouteHelperItem[] = {{routes}};

`;

      let fileSource = fileTemplate.replace('{{routes}}', allRoutesJson);
      fileSource = fileSource.replace(/"/g, '\'');
      console.log(fileSource)
      debugger;
    })
  }
}
